<template>
  <div class="wrapBox">
    <div class="screenBox">
      <div class="contract-manage">
        <el-radio-group v-model="searchFormData.type" style="margin-right:30px" @change="agreeChange()">
          <el-radio-button label="1">日</el-radio-button>
          <el-radio-button label="2">周</el-radio-button>
          <el-radio-button label="3">月</el-radio-button>
        </el-radio-group>
        <el-date-picker
          v-show="searchFormData.type !='3'"
          v-model="searchFormData.rangDate"
          value-format="timestamp"
          @change="changeRangDate()"
          type="daterange"
          range-separator="至"
          start-placeholder="开始日期"
          end-placeholder="结束日期"
          :picker-options="pickerOptions"
          :default-time="['00:00:00', '23:59:59']"
          >
        </el-date-picker>
        <el-date-picker
          v-show="searchFormData.type =='3'"
          v-model="searchFormData.rangDate"
          value-format="timestamp"
          @change="changeRangDate()"
          type="monthrange"
          range-separator="至"
          start-placeholder="开始日期"
          end-placeholder="结束日期"
          :picker-options="pickerOptions"
          :default-time="['00:00:00', '23:59:59']"
          >
        </el-date-picker>
      </div>

      <div>
        <el-radio-group v-model="searchFormData.dataType"   @change="setDataType()" >
          <el-radio-button label="1">新增</el-radio-button>
          <el-radio-button label="2">累计</el-radio-button>
        </el-radio-group>
      </div>
    </div>
    <div id="lineChartBox">

    </div> 
    <div class="btnBox">
      <div class="btn cursor" @click="exportAppLink()">导出数据</div>
      <!-- <div class="lookBtn">
        <div class="btn cursor">查看OPPO数据</div>
        <div class="btn cursor">查看vivo数据</div>
        <div class="btn cursor">查看小米数据</div>
        <div class="btn cursor">查看华为数据</div>
      </div> -->
      
    </div>
  </div>
</template>

<script>
var echarts = require("echarts");
export default {
  data(){
    return{
      pickerOptions:{
        disabledDate(time) {
          return time.getTime() >= new Date(new Date().toLocaleDateString()).getTime()
          
        },
      },
      tableData:[],
      searchFormData:{
        appId:'',
        type:"1",
        dataType:"1",//判断是新增还是累计  1新增 2累计
        rangDate: [new Date().getTime() - 30 * 24 * 60 * 60 * 1000, new Date().getTime() - 24 * 60 * 60 * 1000],
        startTime:"",
        endTime:"",
      },
      myLineChart:"",
      lineOption:{
        tooltip: {
          trigger: 'axis'
        },
        legend: {
          data: []
        },
        grid: {
          left: '3%',
          right: '4%',
          bottom: '3%',
          containLabel: true
        },
        xAxis: {
          type: 'category',
          data: []
        },
        yAxis: {
          type: 'value'
        },
         series: [
          {
            name: '',
            type: 'line',
            data: [],
            itemStyle: {    //柱状图的背景色
              normal: {
                color: 'red'
              }
            },
          },
          {
            name: '',
            type: 'line',
            data: [],
            itemStyle: {    //柱状图的背景色
              normal: {
                color: '#91cc75'
              }
            },
          },
          {
            name: '',
            type: 'line',
            data: [],
            itemStyle: {    //柱状图的背景色
              normal: {
                color: '#5470c6'
              }
            },
          },
          {
            name: '',
            type: 'line',
            data: [],
            itemStyle: {    //柱状图的背景色
              normal: {
                color: '#FF9F7F'
              }
            },
          },
         
        ],
      }
    }
  },
  created(){
    this.searchFormData.appId = this.$route.query.appId;
    this.searchFormData.startTime = this.searchFormData.rangDate ? this.searchFormData.rangDate[0]: ''
    this.searchFormData.endTime = this.searchFormData.rangDate ? this.searchFormData.rangDate[1]: ''
  },
  mounted(){
    this.setLineChart();
  },
  methods:{
    //改变日周月时触发  
    agreeChange(){
      if(this.searchFormData.type==1){
        this.searchFormData.rangDate = [new Date().getTime() - 30 * 24 * 60 * 60 * 1000, new Date().getTime() - 24 * 60 * 60 * 1000]
        this.searchFormData.startTime = this.searchFormData.rangDate ? this.searchFormData.rangDate[0]: ''
        this.searchFormData.endTime = this.searchFormData.rangDate ? this.searchFormData.rangDate[1]: ''
      } else if(this.searchFormData.type==2){
        this.searchFormData.rangDate = [new Date().getTime() - 180 * 24 * 60 * 60 * 1000, new Date().getTime() - 24 * 60 * 60 * 1000]
        this.searchFormData.startTime = this.searchFormData.rangDate ? this.searchFormData.rangDate[0]: ''
        this.searchFormData.endTime = this.searchFormData.rangDate ? this.searchFormData.rangDate[1]: ''
      }else{
        this.searchFormData.rangDate = [new Date().getTime() - 365 * 24 * 60 * 60 * 1000, new Date().getTime()]
        this.searchFormData.startTime = this.searchFormData.rangDate ? this.searchFormData.rangDate[0]: ''
        this.searchFormData.startTime=new Date(this.searchFormData.startTime).setDate(1);
        this.searchFormData.endTime = this.searchFormData.rangDate ? this.searchFormData.rangDate[1]: ''
      }
      this.setLineChart();
    },
    
    setDataType(){
      this.setLineChart();
    },

    //选择时间时触发
    changeRangDate(){
      this.searchFormData.startTime = this.searchFormData.rangDate ? this.searchFormData.rangDate[0]: '';
      if(this.searchFormData.type == '3'){
          var date = new Date(this.searchFormData.rangDate[1]);
          // 下月1号-1秒 
          this.searchFormData.endTime = new Date(date.getFullYear(), date.getMonth() + 1, 1).getTime()-1000;
      }else{
        this.searchFormData.endTime = this.searchFormData.rangDate ? this.searchFormData.rangDate[1]: '';
      }
      this.setLineChart();
    },

 

    //获取折线图数据
    setLineChart() {
      var lineChart=document.getElementById("lineChartBox");
      // lineChart.style.width=window.innerWidth-300+'px';
      this.myLineChart = echarts.init(lineChart);
      this.$apis.consoleSever.queryLinkDistributionData(this.searchFormData).then(res=>{
        if (res['code'] == 0 && res.data.chart.series) {
          this.lineOption.legend.data=res.data.chart.legend;
          this.lineOption.xAxis.data=res.data.chart.xAxis;
          for(let key in res.data.chart.series){
            this.lineOption.series[key]["name"]=res.data.chart.series[key]["name"];
            this.lineOption.series[key]["data"]=res.data.chart.series[key]["data"];
          }
          this.myLineChart.setOption(this.lineOption,true);
          window.addEventListener('resize', () => {
            // lineChart.style.width=window.innerWidth-300+'px';
            this.myLineChart.resize();
          })
        }else{
            for (var i = 0; i < this.lineOption.series.length; i++) {  //置空关键！！！  清空名字和数据
            this.lineOption.series[i].data = [];
            // this.lineOption.series[i].name = '';
          }
          this.lineOption.xAxis.data=[];
          this.myLineChart = echarts.init(lineChart)  //再次初始化
          this.myLineChart.setOption(this.lineOption, true)  //重新setOption
        }
      })
    },

    exportAppLink(){
      this.$apis.consoleSever.exportLinkDistributionData(this.searchFormData).then(res => {
        if (res['code'] == 0 && res['data']['link']) {
          let link = res.data.link;
          window.location.href = link;
        }
      });
    }
    

  }
}
</script>

<style scoped lang="scss">
.wrapBox{
  margin-top: 0;
  #lineChartBox{
    margin-top:30px;
    width: 100%;
    height: 500px;
  }
  .screenBox{
    display: flex;
    justify-content: space-between;
  }
  .btnBox{
    .btn{
      width: 110px;
      height: 40px;
      line-height: 40px;
      text-align: center;
      background: #2E84FC;
      color: #fff;
      border-radius: 5px;
      margin: 0 auto;
        &:hover{
        opacity: .8;
      }
    }
    .lookBtn{
      margin-top:20px ;
      display: flex;
    }
    
  }
  /deep/ .el-table__header th {
      border-bottom: 1px solid rgba(0,0,0,.1) !important;
      padding: 0;
      height: 32px!important;
      background: #F5F5F5;
    }
}
</style>
<style lang="scss">
.contract-manage {
  .el-range-separator {
    width: 24px;
  }
}
</style>
